/**
 * cart
 */
 import Storage from 'store2'               //  本地存储

 const storageCartKey = 'cartData';					//	本地缓存key
 let storageCartData = Storage.get(storageCartKey); 	//	从缓存中获得数据
 
 //	数据内容
 let state = {
	 cartData: storageCartData ? storageCartData : {}, //	Cart信息
 }
 
 //	同步
 const mutations = {
	 setCartDataSync(state, cartData) {
		 //	赋值Cart信息
		 Storage.set(storageCartKey, cartData); //	将数据保存到缓存中
		 state.cartData = cartData;
	 },
 
 }
 
 //	异步，外部保存数据调用此内部方法
 const actions = {
	 setCartData({
		 commit
	 }, cartData) {
		 //	赋值Cart信息
		 commit("setCartDataSync", cartData);
	 },
 }
 
 //	获取
 const getters = {
	 getCartData(state) {
		 //	获取Cart信息
		 return state.cartData;
	 }
 }
 
 export default {
	 namespaced: true,
	 state,
	 getters,
	 actions,
	 mutations
 }
 